import { tlStore } from "../CorBase/CoreBase";

export function getJwtToken(): string | null {
	return tlStore.state.TOKEN_JwtToken;
}

export function getRefreshToken(): string | null {
	return tlStore.state.TOKEN_RefreshToken;
}

export function setTokens(jwtToken: string, refreshToken: string) {
	tlStore.commit('setTokens', {
		jwtToken: jwtToken,
		refreshToken: refreshToken
	});
}

export function clearTokens() {
	tlStore.commit('clearTokens');
}